import React, { Component } from 'react';
import GrayNavBar from './layout/gray-navbar';
import Router from 'react-router'
import Spinner from './generic/spinner';
import Parse from 'parse';


export default class Logout extends Component {

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    };

    constructor(props, context){
        super(props, context);
        this.state = {
            error:null
        };
    }

    componentDidMount() {
        Parse.User.logOut().then(
            () => {
                this.context.router.replace('/');
            },
            () => {
                this.setState({
                    error:'Error occured while logging out. Please try again.'
                });
            }
        );
    }

    render(){

        return (
            <div>
                <Spinner/>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// src/components/logout.js